// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KYt2b","delete":"styles_delete__2MhUY","update":"styles_update__2jOiW","add":"styles_add__34G8B"};